import {
  useGetMasterDistrict,
  useGetMasterProvince,
} from "hooks/useMasterData";
import {
  CloseOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  FormInstance,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import {
  GeographyResponse,
  GetLogoBankResponse,
  MasterDistrictData,
  MasterProvinceData,
  TransportationTypeItems,
} from "services/interface";
const { Option } = Select;

interface ShippingDescriptionFormProps {
  is_active: boolean;
  data: TransportationTypeItems[] | undefined;
  dataGeography: GeographyResponse | undefined;
  edit?: boolean;
  form: FormInstance;
  province_id?: number | undefined | null;
  district_id?: number | undefined | null;
  is_free?: boolean;
}

const formItemLeftLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const formItemRightLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const ShippingDescriptionForm: FC<ShippingDescriptionFormProps> = ({
  is_active,
  data,
  dataGeography,
  edit,
  form,
  province_id,
  district_id,
  is_free,
}) => {
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);

  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const [geolocationType, setGeolocationType] = useState<string>("");

  const [freeShipping, setFreeShipping] = useState<boolean>(false);

  console.log("geolocationType", geolocationType);

  const childrenTransportationType: React.ReactNode[] = [];
  childrenTransportationType.push(
    <Option key="" value="">
      เลือกประเภทการขนส่ง
    </Option>
  );

  data?.map((item) => {
    if (item.key === "transport_free") {
      return;
    }
    return childrenTransportationType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenGeolocation: React.ReactNode[] = [];
  dataGeography?.map((item) => {
    if (item.id === 7) return;
    return childrenGeolocation.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterProviceData, isLoading: proviceLoading } =
    useGetMasterProvince();

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    return childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(provinceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  useEffect(() => {
    if (geolocationType === "all") {
      form.setFieldsValue({
        geolocation_key: undefined,
        province: undefined,
        district: undefined,
      });
    } else if (geolocationType === "geolocation") {
      form.setFieldsValue({
        province: undefined,
        district: undefined,
      });
    } else if (geolocationType === "province") {
      // form.setFieldsValue({
      //   geolocation_key: undefined,
      // });
    }
  }, [geolocationType, form]);

  useEffect(() => {
    if (province_id) {
      setProvinceId(province_id);
      form.setFieldsValue({
        province: province_id,
      });
      setGeolocationType("province");
      form.setFieldsValue({
        geolocation_type: "province",
      });
    }

    if (district_id) {
      setDistrictId(district_id);
      form.setFieldsValue({
        district: district_id,
      });
    }

    console.log("is_free---->", is_free);


    if (is_free !== undefined && is_free !== null) {
      setFreeShipping(is_free);
      form.setFieldsValue({
        free_shipping: is_free,
      });
    }
  }, [province_id, district_id, is_free]);

  return (
    <FormWrapper>
      {/* <Form.Item
        label="พื้นที่จัดส่ง"
        name="geolocation_key"
        rules={[{ required: is_active, message: "กรุณาเลือกพื้นที่จัดส่ง" }]}
      >
        <Select placeholder="พื้นที่จัดส่ง" optionFilterProp="children">
          {childrenGeolocation}
        </Select>
      </Form.Item> */}
      <Form.Item
        label=""
        name="geolocation_type"
        rules={[{ required: is_active, message: "กรุณาเลือกพื้นที่จัดส่ง" }]}
      >
        <Radio.Group
          style={{ display: "flex", flexDirection: "column", marginBottom: 10 }}
          disabled={edit}
        >
          <Radio
            value={"all"}
            style={{ marginBottom: 0 }}
            onClick={() => {
              setGeolocationType("all");
            }}
          >
            ทั้งประเทศ
          </Radio>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              // marginTop: 20,
              alignItems: "center",
            }}
          >
            <Radio
              value={"geolocation"}
              style={{ marginBottom: 0 }}
              onClick={() => {
                setGeolocationType("geolocation");
              }}
            />
            <Form.Item
              label="พื้นที่จัดส่ง"
              name="geolocation_key"
              rules={[
                geolocationType === "geolocation"
                  ? { required: is_active, message: "กรุณาเลือกพื้นที่จัดส่ง" }
                  : { required: false },
              ]}
              required={geolocationType === "geolocation"}
              style={{ marginTop: 20 }}
            >
              <Select
                placeholder="พื้นที่จัดส่ง"
                optionFilterProp="children"
                style={{ width: "400px" }}
                onChange={(value) => {}}
                disabled={geolocationType !== "geolocation" || edit}
              >
                {childrenGeolocation}
              </Select>
            </Form.Item>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              width: "100%",
              // marginTop: 20,
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
              <Radio
                value="province"
                onClick={() => {
                  setGeolocationType("province");
                }}
              />
            </div>
            <div style={{ flex: 5 }}>
              <Form.Item
                label="จังหวัด"
                className="form-transport"
                name="province"
                required={geolocationType === "province"}
                rules={[
                  geolocationType === "province"
                    ? {
                        required: true,
                        message: "กรุณาเลือกจังหวัด",
                      }
                    : { required: false },
                ]}
              >
                <Select
                  // style={{ width: "250px" }}
                  showSearch
                  placeholder="จังหวัด"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setProvinceId(value);
                    form.setFieldsValue({
                      district: undefined,
                    });
                  }}
                  notFoundContent={
                    proviceLoading ? <Spin size="small" /> : null
                  }
                  loading={proviceLoading}
                  disabled={geolocationType !== "province" || edit}
                >
                  {childrenProvince}
                </Select>
              </Form.Item>
            </div>
            <div style={{ flex: 5 }}>
              <Form.Item
                label="อำเภอ"
                className="form-transport"
                name="district"
                // required
                // rules={[
                //   {
                //     required: false,
                //     message: "กรุณาเลือกอำเภอ",
                //   },
                // ]}
              >
                <Select
                  showSearch
                  // style={{ width: "250px" }}
                  placeholder="อำเภอ"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setDistrictId(value);
                  }}
                  notFoundContent={
                    districtLoading ? <Spin size="small" /> : null
                  }
                  loading={districtLoading}
                  disabled={geolocationType !== "province" || edit}
                >
                  {childrenDistrict}
                </Select>
              </Form.Item>
            </div>
          </div>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="ประเภทการขนส่ง"
        name="transportation_key"
        rules={[{ required: is_active, message: "กรุณาเลือกประเภทการขนส่ง" }]}
      >
        <Select
          placeholder="ประเภทการขนส่ง"
          optionFilterProp="children"
          disabled={edit}
        >
          {childrenTransportationType}
        </Select>
      </Form.Item>
      {/* ** ถ้ามากกว่าที่กำหนด จะเป็นการจัดส่งฟรีได้ */}
      {/* <Form.Item
        label="ค่าส่งปกติ"
        name="service_price"
        rules={[{ required: is_active, message: "กรุณากรอกค่าส่งปกติ" }]}
      >
        <Input
          placeholder="ค่าส่งปกติ"
          maxLength={120}
          size="small"
          autoComplete="off"
          type="number"
        />
      </Form.Item> */}
      {/* <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            {...formItemLeftLayout}
            label="ราคาที่สั่งซื้อ"
            name="transport_rate"
            rules={[
              { required: is_active, message: "กรุณากรอกราคาที่สั่งซื้อ" },
            ]}
          >
            <Input
              placeholder="กรุณากรอกราคาที่สั่งซื้อ"
              size="small"
              autoComplete="off"
              type="number"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...formItemRightLayout}
            label="ค่าส่งตามเงื่อนไข"
            name="service_discount_price"
            rules={[
              { required: is_active, message: "กรุณากรอกค่าส่งตามเงื่อนไข" },
            ]}
          >
            <Input
              placeholder="ค่าส่งตามเงื่อนไข"
              size="small"
              autoComplete="off"
              type="number"
            />
          </Form.Item>
        </Col>
      </Row> */}
      <Form.Item label="" name="free_shipping">
        <Checkbox
          checked={freeShipping}
          onChange={(e) => {
            setFreeShipping(e.target.checked)
            form.setFieldsValue({
              free_shipping: e.target.checked,
            })
          }}
        >
          จัดส่งฟรี
        </Checkbox>
      </Form.Item>

      <Form.Item label="หมายเหตุ" name="remark">
        <Input
          placeholder="หมายเหตุ"
          maxLength={120}
          size="small"
          autoComplete="off"
          type="text"
        />
      </Form.Item>

      {!freeShipping && (
        <>
      <Form.List name="transportRate">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Space
                key={key}
                style={{ display: "flex", marginBottom: 8 }}
                align="baseline"
              >
                <Form.Item
                  {...restField}
                  label="น้อยกว่า"
                  name={[name, "totalPrice"]}
                  rules={[
                    { required: true, message: "กรุณากรอกมูลค่าสินค้ารวม" },
                    {
                      validator: (_, value) => {
                        if (value < 1) {
                          return Promise.reject(
                            "กรุณากรอกมูลค่าสินค้ารวมให้ถูกต้อง"
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="มูลค่าสินค้ารวม"
                    maxLength={120}
                    size="small"
                    autoComplete="off"
                    type="number"
                  />
                </Form.Item>
                <Form.Item
                  {...restField}
                  label="จะได้รับค่าส่ง"
                  name={[name, "transportPrice"]}
                  rules={[
                    { required: true, message: "กรุณากรอกค่าส่ง" },
                    {
                      validator: (_, value) => {
                        if (value < 1) {
                          return Promise.reject("กรุณากรอกค่าส่งให้ถูกต้อง");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="ค่าส่ง"
                    maxLength={120}
                    size="small"
                    autoComplete="off"
                    type="number"
                    min={0}
                  />
                </Form.Item>
                {index === fields.length - 1 && (
                  <MinusCircleOutlined onClick={() => remove(name)} />
                )}
              </Space>
            ))}
            <Form.Item
              wrapperCol={{ span: 12, offset: 6 }}
              style={{ textAlign: "center" }}
            >
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                เพิ่มขั้นบันไดค่าส่ง
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      {
        // ** ถ้ามากกว่าที่กำหนดตามขั้นบันได้จะได้รับค่าส่งคือ
      }
      <Form.Item
        label="ถ้ามูลค่าสินค้ารวมมากกว่าที่กำหนดตามขั้นบันไดจะได้รับค่าส่งคือ"
        name="more_then_service_price"
        rules={[
          { required: true, message: "กรุณากรอกค่าส่ง" },
          {
            validator: (_, value) => {
              if (value < 0) {
                return Promise.reject("กรุณากรอกค่าส่งให้ถูกต้อง");
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          placeholder="ค่าส่ง"
          maxLength={120}
          size="small"
          autoComplete="off"
          type="number"
          min={0}
        />
      </Form.Item>

      <Form.Item>
        <Alert
          message="คำเตือน"
          description="กรุณากรอกตามลำดับราคาเพื่อความเข้าใจง่ายในการจัดการ"
          type="warning"
          showIcon
          />
        </Form.Item>
      </>
      )}
    </FormWrapper>
  );
};

export default ShippingDescriptionForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
`;
